var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencyPln(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1516_136716)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1516_136716)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8.00391,
    width: 46.1221,
    height: 30.6785,
    rx: 5.76455,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1182 0H-8.00391V30.6785H38.1182V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1182 15.3394H-8.00391V30.6786H38.1182V15.3394Z",
    fill: "#DC143C"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -8.00391,
    width: 46.1221,
    height: 30.6785,
    rx: 5.76455,
    stroke: "#E5E5E5",
    strokeWidth: 1.44114,
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#E5E5E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1516_136716"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1516_136716"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8.00391,
    width: 46.1221,
    height: 30.6785,
    rx: 5.76455,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyPln);
export default __webpack_public_path__ + "static/media/Currency=PLN.288f5cd61e887f551937e8939eec9774.svg";
export { ForwardRef as ReactComponent };